'use client';

import { useEffect, useState } from 'react';
import Image from 'next/image';

interface AvatarWithAnimatedCircleProps {
  imageSrc: string;
  alt: string;
  size?: 'sm' | 'md' | 'lg';
  pulsate?: boolean;
}

export default function AvatarWithAnimatedCircle({ 
  imageSrc, 
  alt, 
  size = 'md',
  pulsate = false
}: AvatarWithAnimatedCircleProps) {
  // Size configurations with padding for visible border
  const sizes = {
    sm: {
      image: 'w-8 h-8',
      border: 'w-10 h-10' // Larger to create visible border
    },
    md: {
      image: 'w-12 h-12',
      border: 'w-14 h-14' // Larger to create visible border
    },
    lg: {
      image: 'w-20 h-20',
      border: 'w-[92px] h-[92px]' // Larger to create visible border
    }
  };

  return (
    <div className="flex justify-center items-center relative">
      {/* Animated border gradient - positioned behind the image */}
      <div 
        className={`absolute ${sizes[size].border} rounded-full animate-spin-slow bg-gradient-to-r from-[rgb(44,208,115)] via-yellow-500 to-pink-600`} 
      />
      {/* Avatar image with padding to allow border to be visible - now with scale animation */}
      <div className={`${sizes[size].image} rounded-full overflow-hidden border-2 border-white z-10 relative bg-white ${pulsate ? 'animate-scale-slow' : ''}`}
           style={{ boxShadow: '0 0 0 4px rgba(255,255,255,0.8)' }}>
        {imageSrc && <Image
          src={imageSrc}
          alt={alt} 
          className="w-full h-full object-cover"
          width={64}
          height={64}
        />}
      </div>
    </div>
  );
} 